/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum DropdownType {
    DESCRIPTION = 'DESCRIPTION',
    TREE = 'TREE',
    CODE = 'CODE'
}
